import React from "react";
import {Button, Col, Row, Space, Input, Form } from "antd";
import {Link} from "react-router-dom";
import Navbar from "../Layout/Navbar";
import { ClockCircleOutlined, ShoppingCartOutlined , LoadingOutlined} from '@ant-design/icons';
import "./landing.css"
import {compose} from "redux";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import { fruits } from "../Items/fruits"
import CustomFooter from "../Layout/Footer";

class Landing extends React.Component {

    state = {
        lat: 18.5204,
        long: 73.8567
    }


    render() {
        const { items } = this.props;

        return (
            <div>
                <div className="uk-background-default">

                    <div className="uk-padding-large uk-padding-remove-vertical">
                        <Row gutter={8}>
                            <Col span={12}>
                                <div className="uk-width-1-1 uk-padding-large">
                                    <div>
                                        <h1 className="uk-h1 uk-text-bold uk-margin-remove">
                                            Tañda
                                        </h1>
                                        <h2 className="uk-h2 uk-margin-bottom uk-margin-remove-top">
                                            Закажите продукты прямо до двери без предоплаты
                                        </h2>
                                        <p className="uk-h5 uk-margin-top">
                                            Вы можете найти все нужные продукты для вашего вкусного рецепта из более 4500 продуктов
                                        </p>
                                        <Space>
                                            <a className="uk-text-left" href={"https://apps.apple.com/kz/app/nulife/id1498300799"}>
                                                <img width={144} src={require("../Layout/appstore.png")} />
                                            </a>
                                            <a href={"https://play.google.com/store/apps/details?id=com.naltynbekkz.nulife"}>
                                                <img width={144} src={require("../Layout/playstore.png")} />
                                            </a>
                                        </Space>
                                        <br />
                                    </div>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="uk-text-center uk-padding">
                                    <img className="uk-height-large" src="https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1536158012259x187802105443552130%2FiPhone.png?w=512&h=608&auto=compress&fit=max" />
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <section className="uk-background-default">
                        <div className="uk-padding uk-padding-remove-horizontal uk-container ">
                            <div className="uk-text-center">
                                <h3 className="uk-h2 uk-margin-small-bottom uk-text-bold">
                                    Как вы можете заказать на нашей платформе
                                </h3>
                                <p className="uk-h4 uk-margin-remove-top uk-margin-bottom uk-container uk-container-small">
                                    Наша платформа предлагает вам заказать нужные продукты за 3 шага. Вы можете группировать продукты для каждого магазина
                                </p>
                            </div>
                            <div className="uk-margin-large-top">
                                <Row gutter={24} className="uk-grid-match">
                                    <Col span={8}>
                                        <div className="uk-text-center">
                                            <div className="uk-padding-large uk-padding-remove-vertical">
                                                <img className="uk-height-small" src={require("./undraw_online_groceries_a02y.svg")} />
                                            </div>
                                            <h5 className="uk-margin-top uk-text-uppercase">
                                                Выберите продукт
                                            </h5>
                                            <p>
                                                Вы можете также выбрать алтерьнативные продукты и узнать их цены
                                            </p>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="uk-text-center">
                                            <div className="uk-padding-large uk-padding-remove-vertical">
                                                <img className="uk-height-small" src={require("./undraw_shopping_app_flsj.svg")} />
                                            </div>
                                            <h5 className="uk-margin-top uk-text-uppercase">
                                                Сделайте заказ
                                            </h5>
                                            <p>
                                                Следите или получайте уведомления о статусе вашего заказа
                                            </p>
                                        </div>
                                    </Col>
                                    <Col span={8}>
                                        <div className="uk-text-center">
                                            <div className="uk-padding-large uk-padding-remove-vertical">
                                                <img className="uk-height-small" src={require("./undraw_on_the_way_ldaq.svg")} />
                                            </div>
                                            <h5 className="uk-margin-top uk-text-uppercase">
                                                Получите ваш заказ
                                            </h5>
                                            <p>
                                                Доставим вам до двери. Авто-сохраненные чеки ваших заказов
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </section>

                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {

    let items = [];
    let categories = [];
    if(state.firestore.ordered.items) {
        items = state.firestore.ordered.items.map(item => {
            if(!categories.includes(item.category)){
                categories.push(item.category);
            }
            return {
                key: item.id,
                ...item
            }
        })
    }

    console.log(state.firestore.ordered)


    return {
        auth: state.firebase.auth,
        items: items,
        categories: categories.map(category => {
            return {
                text: category,
                value: category
            }
        })
    }
}

const enhance = compose(
    firestoreConnect([
        { collection: "items" }
    ]),
    connect(mapStateToProps)
);
export default enhance(Landing);



// WEBPACK FOOTER //
// ./src/Components/Landing/index.js